import audioDescription from './audio-description.svg';
import closedCaptions from './closed-captions.svg';
import dolbyAtmos from './dolby-atmos.svg';
import dolbyVision from './dolby-vision.svg';

export const logos = {
  'audio-description': audioDescription,
  'closed-captions': closedCaptions,
  'dolby-atmos': dolbyAtmos,
  'dolby-vision': dolbyVision,
} as const;

export type MetadataLogoName = keyof typeof logos;
